import { render, staticRenderFns } from "./ModalAddProduto.vue?vue&type=template&id=754904e8"
import script from "./ModalAddProduto.vue?vue&type=script&lang=js"
export * from "./ModalAddProduto.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduto.vue?vue&type=style&index=0&id=754904e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports